const safeSum = (a, b) => {
    if (!a || isNaN(a))
        a = 0;
    if (!b || isNaN(b))
        b = 0;
    return a + b;
};
const sumItemQuantities = (items) => {
    if (!items) {
        return 0;
    }
    return items === null || items === void 0 ? void 0 : items.reduce((total, item) => { var _a; return safeSum(total, item ? (_a = item.quantity) !== null && _a !== void 0 ? _a : 1 : 0); }, 0);
};
const sumAllItemQuantities = (item) => {
    return (item === null || item === void 0 ? void 0 : item.reduce((total, i) => safeSum(total, sumItemQuantities(i === null || i === void 0 ? void 0 : i.items)), 0)) || 0;
};

export { sumAllItemQuantities, sumItemQuantities };
//# sourceMappingURL=checkout.js.map
